import { FC } from "react";
import { useHotelBookingContext } from "../context/HotelBookingContext";
import { SecondarySearch } from "../../../Components";
import HeroGallery from "../components/HeroGallery";
import HotelHeader from "../components/HotelHeader";
import BookingTabs from "../components/BookingTabs";
import PropertyPolicies from "../components/PropertyPolicies";
import PopularAmenities from "../components/PopularAmenities";
import AccommodationsList from "../components/AccommodationsList";
import PremiumAmenities from "../components/PremiumAmenities";
import LocationInfo from "../components/LocationInfo";
import { HotelBookingSharedProps } from "../HotelBooking";
import CountdownTimerSlider from "../../../Components/CountdownTimerSlider/CountdownTimerSlider";

const HotelBookingMobile: FC<HotelBookingSharedProps> = ({
  sections,
  overviewRef,
  popularAmenitiesRef,
  roomsRef,
  amenitiesRef,
  locationRef,
  extraGuestCharges,
  handleProceed,
}) => {
  const { hotel, searchObject, selectedRoomIndex, setSelectedRoomIndex, selectedBookingCode, numberOfNights, pointsFactor } =
    useHotelBookingContext();

  return (
    <div className="flex flex-col bg-background-default">
      {/* Compact search bar */}
      <div className="flex w-full items-center border-b border-border-default p-4">
        <div className="flex-1">
          <SecondarySearch initialValues={searchObject} />
        </div>
      </div>
      <div className="sticky top-0 z-20">
        <CountdownTimerSlider />
      </div>

      <div className="flex flex-col gap-6 p-4 pb-16">
        {/* <SummarySidebar searchObject={searchObject} /> */}

        <HeroGallery images={hotel.images} fallbackImage={hotel.image} hotelName={hotel.hotelName} />

        <HotelHeader
          hotelName={hotel.hotelName}
          hotelRating={hotel.hotelRating}
          address={hotel.address}
          hotelWebsiteUrl={hotel.hotelWebsiteUrl}
          description={hotel.description}
          latitude={hotel.latitude}
          longitude={hotel.longitude}
        />
        
        <div className="sticky top-11 z-10 -mx-4 scroll-mt-24 bg-background-default px-4">
          <BookingTabs sections={sections} />
        </div>

        <div ref={overviewRef} data-section-key="overview" className="scroll-mt-24">
          <PropertyPolicies
            checkInTime={hotel.checkInTime}
            checkOutTime={hotel.checkOutTime}
            phoneNumber={hotel.phoneNumber}
            extraGuestCharges={extraGuestCharges}
            currency={hotel.currency}
          />
        </div>

        <div ref={popularAmenitiesRef} data-section-key="popularAmenities" className="scroll-mt-24">
          <PopularAmenities categorizedFacilities={hotel.categorizedFacilities}/>
        </div>

        <div ref={roomsRef} data-section-key="rooms" className="scroll-mt-24">
          <AccommodationsList
            rooms={hotel.rooms}
            currency={hotel.currency}
            originalCurrency={hotel.originalCurrency}
            numberOfNights={numberOfNights}
            selectedIndex={selectedRoomIndex}
            onSelect={setSelectedRoomIndex}
            onProceed={handleProceed}
            pointsFactor={pointsFactor}
            totalAdults={searchObject?.rooms?.reduce((sum, r) => sum + (r.adults ?? 0), 0) ?? 0}
            totalChildren={searchObject?.rooms?.reduce((sum, r) => sum + (r.children ?? 0), 0) ?? 0}
          />
        </div>

        <div ref={amenitiesRef} data-section-key="amenities" className="scroll-mt-24">
          <PremiumAmenities facilities={hotel.categorizedFacilities} />
        </div>

        <div ref={locationRef} data-section-key="location" className="scroll-mt-24">
          <LocationInfo attractions={hotel.attractions} latitude={hotel.latitude} longitude={hotel.longitude} />
        </div>

        <input type="hidden" data-testid="booking-code" value={selectedBookingCode ?? ""} />
      </div>
    </div>
  );
};

export default HotelBookingMobile;
